import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ReservationsService } from '../reservation.service';
import { Reservation } from '../reservation';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ReservationsComponent } from '../reservation/reservation.component';

@Component({
    selector: 'app-reservations-list',
    templateUrl: './reservation-list.component.html',
    styleUrls: ['./reservation-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ReservationsListComponent implements OnInit {
	isSearching = false;
	constructor(
		private reservationService: ReservationsService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		public constantService: ConstantService,
		private activatedRoute: ActivatedRoute,
		private datePipe: DatePipe,
		private dialog: MatDialog,
	) {
		this.statuses = reservationService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() titleFontSize = false;
	@Input() propertyId: any;
	reservations: any;
	reservation: Reservation;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	//URL Filter
	filterCreateDay: any;
	filterUpdateDay: any;

	columns: any[] = [
		{ field: 'reservationStatus', header: 'Status', width: 'auto' },
		{ field: 'PropertyVO.propertyCode', header: 'Property', width: 'auto' },
		// { field: 'createDate', header: 'Created', width: 'auto' },
		{ field: 'lastname', header: 'Name', width: 'auto' },
		{ field: 'checkInDate', header: 'Arrival', width: 'auto' },
		{ field: 'checkOutDate', header: 'Departure', width: 'auto' },
		{ field: 'numNights', header: 'Nights', width: 'auto' },
		{ field: 'numAdults', header: 'Guests', width: 'auto' },
		{ field: 'roomRatePN', header: 'Rate', width: 'auto' },
		{ field: 'reservationId', header: 'YM ReservationId', width: 'auto' },
		{ field: 'extReservationId', header: 'Wiki ReservationId', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			this.activatedRoute.queryParamMap.subscribe(params =>
			{
				this.filterCreateDay = params.get('createDate');
				this.filterUpdateDay = params.get('updateDate');;
			});

			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'checkInDate', order: -1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.reservationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-reservation-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				// event.multiSortMeta.push({ field: 'createDate', order: -1 });
				event.multiSortMeta.push({ field: 'checkInDate', order: -1 });
			}

			if(this.propertyId)
				{
					// show only activities that are assigned to this activityFeeId
					let propertyIdFilter = { 'propertyVO.propertyId': { 'value': this.propertyId, 'matchMode': 'in' } };
					Object.assign(event.filters, propertyIdFilter);
				}

			if(this.filterCreateDay != null)
			{
				let filterCreateDay = this.addLocalTimeToDateTime(new Date(this.filterCreateDay));
				let date = this.datePipe.transform(filterCreateDay, 'yyyy-MM-ddThh:mm');
				event.filters['createDate'] = {"value":date,"matchMode":"in"};
			}

			if(this.filterUpdateDay != null)
			{
				let filterUpdateDay = this.addLocalTimeToDateTime(new Date(this.filterUpdateDay));
				let date = this.datePipe.transform(filterUpdateDay, 'yyyy-MM-ddThh:mm');
				event.filters['lastUpdate'] = {"value":date,"matchMode":"in"};
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.reservationService.findReservationsByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.reservations = res.data.reservations;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.reservations = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(reservation: Reservation) {
		try {
			this.formLoading = true;
			this.reservationService.update(reservation)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.reservations.map((reservation, i) => {
							if (reservation.reservationId === res.data.reservation.reservationId) {
								this.reservations[i] = res.data.reservation;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(reservation: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(reservation));

			this.formLoading = true;
			this.reservationService.delete(reservation.reservationId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.reservations.splice(this.reservations.indexOf(reservation), 1);
						this.recordTotal = this.reservations.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Reservation ' + reservation.reservationId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Reservation ' + reservation.reservationId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Reservation'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(reservation: Reservation) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "100vw";
		dialogConfig.width = "100vw";
		dialogConfig.maxHeight = "100vh";
		dialogConfig.height = "100vh";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			reservation: reservation,
			title: 'Edit Reservation'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addReservationCB(reservation: Reservation) {
		console.log('Adding Reservation: ' + JSON.stringify(reservation));
		// if we don't have a reservations array yet...
		if (!this.reservations) {
			this.reservations = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.reservations.unshift(reservation);

		// no idea what this is but it is required to update the array
		this.reservations = [...this.reservations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Added', life: 3000 });
	}

	updateReservationCB(reservation: Reservation) {
		console.log('Updating Reservation: ' + JSON.stringify(reservation));
		let itemIndex = this.reservations.findIndex((item: any) => item.reservationId === reservation.reservationId);
		this.reservations[itemIndex] = reservation;

		// no idea what this is but it is required to update the array
		this.reservations = [...this.reservations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Updated', life: 3000 });
	}

	deleteReservationCB(reservation: Reservation) {
		console.log('Removing Reservation: ' + reservation);
		this.reservations.splice(this.reservations.indexOf(reservation), 1);
		this.recordTotal = this.reservations.length;

		// no idea what this is but it is required to update the array
		this.reservations = [...this.reservations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Deleted', life: 3000 });
	}

	syncReservationsByPropertyConfirmation() {
		this.confirmationService.confirm({
			message: 'Are you sure? this process will take some time to complete, this process will run in background.',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.syncReservationsByProperty();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	syncReservationsByProperty() {
		try {
			this.reservationService.syncReservationsByProperty(this.propertyId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sync All Properties successfully', life: 3000 });
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.reservations ? this.first === (this.reservations.length - this.rows) : true; }
	isFirstPage(): boolean { return this.reservations ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(reservation: any) {
		if (reservation?.status) {
			const status = this.statuses.find((e: any) => e.value == reservation.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	getResStatusName(resStatus, reservationType)
  {
	if(resStatus != null && reservationType!= null)
	{
		return this.constantService.reservationWikiStatuses.find(function (item) { return item.value === resStatus && item.type === reservationType  }).label;
	}
	else
	{
		return '';
	}
  }

  getResStatusColor(resStatus, reservationType) {
	return this.constantService.reservationWikiStatuses.find(function(item) { return item.value === resStatus && item.type === reservationType })?.color;
	}

	syncAllReservations() {
		try {
			this.reservationService.syncAllReservations()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sync All Reservations Successfully', life: 3000 });
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	syncAllReservationsConfirmation() {
		this.confirmationService.confirm({
			message: 'Are you sure? this process will take some time to complete, this process will run in background',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.syncAllReservations();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
